import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/lenis";
import Home from "@/pages/Home";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import Fulfillment from "@/pages/Fulfillment";
import TrackOrder from "@/pages/TrackOrder";
import ReviewSubmit from "@/pages/ReviewSubmit";
import Legal from "@/pages/Legal";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen grid place-items-center bg-[#FBF9F5] text-[#1A2320] font-sans">
                    <p>Une erreur est survenue. Rechargez la page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    useEffect(() => {
        initLenis();
    }, []);
    return null;
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollManager />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/payment/success" element={<CheckoutSuccess />} />
                    <Route path="/payment/cancel" element={<CheckoutCancel />} />
                    <Route path="/fulfillment" element={<Fulfillment />} />
                    <Route path="/suivi" element={<TrackOrder />} />
                    <Route path="/avis" element={<ReviewSubmit />} />
                    <Route path="/legal" element={<Legal />} />
                </Routes>
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
